import React from '../helpers/react';
import Solution from '../components/Solution.js';
import Loader from './Loader.js';
import {toggleSolution, postComment} from '../actions/problem.action.js';
import { enableTitleChange } from "../actions/model.action.js";
import {connect} from '../helpers/composeReducer.js';
import {pushPath} from 'redux-simple-router';
import {trigger} from '../helpers/events.js';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

import NoSolution from '../components/NoSolution.js';
import NoAccessSolution from '../components/NoAccessSolution.js';
import ErrorDialog from '../components/ErrorDialog.js';
import {ACCOUNT_OK, ACCOUNT_FLAGGED} from '../modules/apiWrapper.js';

import {ERROR_CODES} from '../helpers/ErrorCodes.js';

import {BAD_TOC} from '../modules/apiWrapper.js';

export const Problem =  React.createClass({
	gotoProblem: function(problem){
        let chapter_identifier = problem.chapter[this.props.use_ids ? 'id' : 'name'];
        let problem_identifier = problem[this.props.use_ids ? 'id' : 'name'];
        this.props.enableTitleChange();
        this.props.pushPath(this.props.buildRoute('problem',{
            chapter : chapter_identifier,
            problem : problem_identifier,
            isbn13  : this.props.isbn13
        }));
	},
    componentDidMount : function(){
        return this.componentDidUpdate();
    },
    componentDidUpdate : function(){
        this.checkLimit();
        this.checkAccess();
        this.checkLoad();
        trigger('contentUpdate');
    },
    checkLimit : function(){
        if (this.props.limit_exceeded) {
            trigger('limitExceeded', this.props.problemId);
            this.limit_checked = true;
        }
    },
    checkAccess : function() {
      if(this.props.do_account_sharing && this.props.access_restriction !== ACCOUNT_OK) {
        trigger('accessRestricted', this.props.access_restriction);
      }
    },
    checkLoad : function(){
        if (this.problem_loaded) return;
        if (this.props.hasSolution && this.props.steps.length) {
            trigger('problemLoaded',{
                chapter : this.props.chapter.chapterName,
                problem : this.props.probleName,
                problemId : this.props.problemId
            });
            this.problem_loaded = true;
        }
    },

    componentWillReceiveProps : function(props) {
        if (props.problemName != this.props.problemName) {
            this.problem_loaded = false;
        }
    },

    getHeader: function() {
        if (this.props.problemHtml) {
            return <header key='header'><h3 className="player-title">{this.props.getDef('problem.title')}</h3></header>;
        }
        return '';
    },

    getContent : function() {
        if (this.props.problemHtml) {
            let content = <div key="html" className="html" dangerouslySetInnerHTML={{__html:this.props.problemHtml}} />

            return <div className="problem-content" key="problem-content">
                <div className="problem-html">{content}</div>
            </div>
        }
        return '';
    },

    getError : function(){
        let title = this.props.unknown_error ? this.props.getDef('solution.title', {}, { problem_exists : true }) : '';

        let code = 0;

        if (this.props.unknown_error) {
            code = ERROR_CODES.PROBLEM_ERROR;
        }else if (this.props.model_error && this.props.model_error.type == BAD_TOC) {
            code = ERROR_CODES.BAD_TOC;
        }else if (this.props.model_error) {
            code = ERROR_CODES.MODEL_ERROR;
        }

        return <ErrorDialog
            key='solution'
            title={title}
            code={code}
            getDef={this.props.getDef}
            />;
    },
    keyDownPreviousProblem: function(e){
        // # Accessibility -- let element respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            if(!this.props.show_fullscreen) document.getElementById('show-all-steps').focus();
            else document.getElementById('fullscreen').focus();
        }
    },

    render : function(){
        let name = this.props.problemName;
        let steps = this.props.steps || [];
        let show_loader = (!this.props.problemHtml && !this.props.problemName);
        let show_solution_loader = (!steps.length && steps.length !== 0 && this.props.problem_exists) || !this.props.problemName;
        let access_flagged = this.props.do_account_sharing && this.props.access_restriction === ACCOUNT_FLAGGED;
        let mainClass = classList('problem', getHookClass('Problem'));

        let problemBody = [
            this.getHeader()
        ];

        if (!show_loader) {
            problemBody.push(
                this.getContent()
            );
        }
        else if (!this.props.unknown_error && !this.props.model_error){
            problemBody.push(Loader('loader-problem'));
        }
        if (this.props.problemHtml) {
            mainClass.push('has-content');
        }
        
        let solution;
        if (this.props.unknown_error || this.props.model_error) {
            solution = this.getError();
            mainClass.push('has-content');
        } else if (!this.props.hasSolution) {
            trigger('noSolutionAccess', {reason: 'no_solution'});
            solution = <NoSolution key='solution'/>;
        } else if (!this.props.has_access || this.props.solution_limit_exceeded || access_flagged) {
            trigger('noSolutionAccess', {reason: 'no_access'});
            solution = <NoAccessSolution key='solution' />
        } else {
            solution = <Solution key='solution' />;
        }

        problemBody.push(solution);

        let prev_disabled = !this.props.prev_problem && !show_loader && !show_solution_loader;
        let next_disabled = !this.props.next_problem && !show_loader && !show_solution_loader;

        this.style = this.style || {};
        let showing_loaders = (show_loader || show_solution_loader);
        if (showing_loaders && !this.style.minHeight && this.refs.problem) {
            let computedStyle = getComputedStyle(this.refs.problem);
            let height = computedStyle.height;
            this.style = {minHeight: height};
        }
        if (!showing_loaders || !this.props.hasSolution) {
            this.style = {};
        }

        return (
            <section ref="problem" style={this.style} className={mainClass} data-id={name} key={name} onContextMenu={(e)=>e.preventDefault()} onCopy={(e)=>e.preventDefault()}>
                <button tabIndex="0" id="problem-previous" onKeyDown={(e)=>this.keyDownPreviousProblem(e)} className="arrow arrow-left" onClick={()=>{this.gotoProblem(this.props.prev_problem)}} disabled={prev_disabled} data-hover={this.props.getDef('problem.prev')} aria-label={prev_disabled ? '':"Previous problem"}/>
                {problemBody}
                <button tabIndex="0" className="arrow arrow-right" onClick={()=>{this.gotoProblem(this.props.next_problem)}} disabled={next_disabled} data-hover={this.props.getDef('problem.next')} aria-label={next_disabled ? '':"Next problem"}/>
            </section>
        );
    }
});

export function mapStateToProps(state){
    let problem = state.problem;
    return {
        ...problem,
        use_ids : state.options.use_id_identifier,
        isbn13 : state.model.isbn13,
        model_error : state.model.error,
        buildRoute : state.helpers.buildRoute,
        getDef : state.helpers.getDef,
        show_fullscreen : state.options.show_fullscreen,
        do_account_sharing : state.options.do_account_sharing
    };
}

export default connect(mapStateToProps,{toggleSolution, postComment, pushPath, enableTitleChange})(Problem);



// WEBPACK FOOTER //
// ./src/components/Problem.js